export const n = (pitch, label, duration = "quarter") => ({ pitch, label, duration });
export const x = (pitch, label, duration = "quarter") => ({ pitch, label, duration, head: "x" });
export const c = (pitches, label, duration = "half") => ({ pitches, label, duration });
export const mc = (id, prompt, options, answer) => ({ id, type: "mc", prompt, options, answer });
